import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Box, Paper, MenuItem, MenuList } from '@material-ui/core';
import servises, { useGetCustomerDetailsQuery } from 'core/services';
import Popper from 'components/Popper';
import api from 'core/services/api';
import Icon from 'components/Icon';
import Text from 'components/Text';
import Button2 from 'components/Button2';
import useSkipForProduct from 'hooks/useSkipForProduct.hook';

const { logout } = servises;

const Profile = ({ classes }) => {
  const isloggedIn = useSelector((state) => state.authorization.isloggedIn);
  const skipForProduct = useSkipForProduct();
  const meQuery = useGetCustomerDetailsQuery(undefined, {
    skip: skipForProduct || !isloggedIn,
  });

  const customerData = meQuery.data;

  const dispatch = useDispatch();
  const [profileMenu, setProfileMenu] = useState(null);

  const handleCloseProfile = () => {
    setProfileMenu(null);
  };

  return (
    <>
      {customerData && (
        <Button2
          variant="text"
          size="medium"
          onClick={(e) => {
            setProfileMenu(e.currentTarget);
          }}
        >
          <Icon.Person fontSize={20} />

          <Text
            lineHeight={1}
            variant="body3-medium"
            color="colors.grey700"
            textTransform="none"
          >
            Hi, {customerData.first_name}
          </Text>
        </Button2>
      )}
      <Popper
        anchorEl={profileMenu}
        open={Boolean(profileMenu)}
        onClose={handleCloseProfile}
      >
        <Paper className={classes.profilePaper}>
          <MenuList className={classes.profileList}>
            <div className={classes.profileTitle}>
              Your Account{' '}
              {customerData?.customer_number && (
                <small className={classes.accountId}>
                  ID: {customerData?.customer_number}
                </small>
              )}
            </div>
            <MenuItem onClick={handleCloseProfile}>
              <Link to="/profile/orders">Orders</Link>
            </MenuItem>
            <MenuItem onClick={handleCloseProfile}>
              <Link to="/profile/requests/quote">Requests</Link>
            </MenuItem>
            <MenuItem onClick={handleCloseProfile}>
              <Link to="/profile/lab">Lab Groups</Link>
            </MenuItem>
            <MenuItem onClick={handleCloseProfile}>
              <Link to="/profile/dashboard">Account</Link>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseProfile();
                logout();
                dispatch(api.util.resetApiState());
              }}
            >
              <Box color={'#EA1763'}>
                <b>Log out</b>
              </Box>
            </MenuItem>
          </MenuList>
        </Paper>
      </Popper>
    </>
  );
};

export default Profile;
